import React, { Component, Fragment} from "react";
import "./login.css";
import { Modal, Button, Form, Icon, Input, Checkbox } from "antd";
import buttonimage from "../../../style/images/login/sign in btn.png";
import fbbutton from "../../../style/images/login/facebook btn.png";
import orBar from "../../../style/images/login/OR.png";
class WrappedNormalLoginForm extends Component {
  state = {
    modal2Visible: true
  };

  setModal2Visible(modal2Visible) {
    this.setState({ modal2Visible });
    this.props.disableLogin();
  }
  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        console.log("Received values of form: ", values);
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const imageClick = () => {
      console.log("Click");
    };
    return (
      <Fragment>
        <Modal
          title={
            <div>
              <h1 className="loginTitle">Sign in</h1>
              <img className="facebookShare" src={fbbutton} />
              <br />
              <br />
              <img className="bar" style={{ width: "100%" }} src={orBar} />
            </div>
          }
          centered
          footer={null}
          visible={this.state.modal2Visible}
          onCancel={() => this.setModal2Visible(false)}
        >
          {/* from this poin the login form starts */}

          <Form onSubmit={this.handleSubmit} className="login-form">
            <Form.Item>
              {getFieldDecorator("username", {
                rules: [
                  { required: true, message: "Please input your username!" }
                ]
              })(
                <Input
                  style={{ color: "white" }}
                  // prefix={
                  //   <Icon type="user" style={{ color: "rgba(0,0,0,.25)" }} />
                  // }
                  placeholder="Enter Email or Username"
                />
              )}
            </Form.Item>
            <Form.Item>
              {getFieldDecorator("password", {
                rules: [
                  { required: true, message: "Please input your Password!" }
                ]
              })(
                <Input
                  // prefix={
                  //   <Icon type="lock" style={{ color: "rgba(0,0,0,.25)" }} />
                  // }
                  type="password"
                  placeholder="Enter Password"
                />
              )}
            </Form.Item>
            <Form.Item>
              {getFieldDecorator("remember", {
                valuePropName: "checked",
                initialValue: true
              })(<Checkbox style={{ color: "white",fontFamily: 'Gilroy'}}>Remember Me!</Checkbox>)}
              <br />
              <br />
              <p className ="c2"
              
              > &nbsp;&nbsp;&nbsp;&nbsp;
                By clicking below, you accept to our <b>Terms of Use</b> and <b>Privacy
                Policy</b>
              </p>

              <div className="row">
                <div className="col-xs-2 col-sm-3 ">
                  <span />
                </div>
                <div className="col-xs-7 col sm-7 centered">
                  <Button
                    style={{ color: "transparent", display: "contents" }}
                    type="image"
                    htmlType="submit"
                  >
                    <img
                      className="login-form-button-login center"
                     
                      src={buttonimage}
                    />
                  </Button>
                </div>{" "}
                <div className="col-xs-2 " />
              </div>

              <p
                style={{
                  fontSize: "small",
                  textAlign: "center",
                  paddingTop: "4%",
                  marginBottom: "-4%",
                  color: "white"
                }}
              >
                Don't have an account?{" "}
                <a  className="underline" onClick={() => this.props.gotoSignupPage()}>SIGN UP</a>
                <br /> <a className="underline">FORGOR PASSWORD?</a>
              </p>
            </Form.Item>
          </Form>
          {/* ending point of the login form */}
        </Modal>
      </Fragment>
    );
  }
}
export const Login = Form.create({ name: "normal_login" })(
  WrappedNormalLoginForm
);
